<!-- @Author: Yu_Bo -->
<template>
    <div class='account_add_edit zc_dialog_box'>
        <el-dialog :visible.sync="dialogVisible" width="504px" :close-on-click-modal='false' @close='cancelBtn'>
            <div slot="title">
                <div class="name">{{ title }}</div>
            </div>
            <div class="inv_main">
                <div class="main_text">
                    <div class="left"><span>*</span>名称</div>
                    <div class="right">
                        <el-input v-model="info.name" maxlength="10" placeholder="请输入名称">
                        </el-input>
                    </div>
                </div>
                <div class="main_text">
                    <div class="left"><span>*</span>封面</div>
                    <div class="right">
                        <el-upload class="r_img" accept="image/jpg,image/jpeg,image/png,image/gif" action="" :before-upload="beforeAvatarUpload" :http-request="httpRequestMultiple" :show-file-list="false">
                            <div v-if="info.cover" class="w100 h100">
                                <img style="width: 80px;height: 80px;" :src="info.cover" alt="">
                            </div>
                            <div class="r_img_no w100 h100" v-else>
                                <i class="el-icon-plus"></i>
                                <div>上传封面</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="main_text" v-if="type==1">
                    <div class="left"><span>*</span>绑定用户</div>
                    <div class="right">
                        <el-select v-model="ids" multiple placeholder="请选择">
                            <el-option v-for="item in vipList" :key="item.mid" :label="item.nickname" :value="item.mid" :disabled="item.binding_status==2">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="main_text" v-if="type==1">
                    <div class="left">状态</div>
                    <div class="right">
                        <el-switch v-model="info.status" :active-value='1' :inactive-value='0'></el-switch>
                    </div>
                </div>
            </div>
            <div slot="footer" style="padding: 0 20px;">
                <el-button class="btnBgColor_grey" size="small" @click="cancelBtn">取 消</el-button>
                <el-button class="btnBgColor_blue" size="small" :loading='btnLoading' type="primary" @click="affirmBtn">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        type: {
            type: Number,
            defaul: 1
        },
    },
    data() {
        return {
            headers: {
                'Authorization': this.$store.state.token
            },
            dialogVisible: false,
            info: {
                cover: "",
                status: 1,
                name: "",
                uid: "",
            },
            id: '',
            btnLoading: false,
            ids: "",
            vipList: "",
        }
    },
    computed: {
        title() {
            return this.type == 1 ? '新增' : '编辑'
        },
    },
    watch: {},
    created() { },
    mounted() {
        this.getVip()
    },
    methods: {
        // 获取会员列表
        getVip() {
            let obj = {
                page: 1,
                limit: 100,
            }
            this.$memberApi.vipUser(obj).then(res => {
                if (res.code == 1000) {
                    this.vipList = res.result
                }
            })
        },
        // 打开弹框
        openDialogBtn(val) {
            if (val) {
                this.info = {
                    cover: val.cover,
                    status: val.status,
                    name: val.name,
                }
                this.id = val.id
            }
            this.dialogVisible = true
        },
        // 取消
        cancelBtn() {
            this.info = {
                cover: "",
                status: 1,
                name: "",
                uid: "",
            }
            this.ids = ""
            this.dialogVisible = false
        },
        // 确定
        affirmBtn() {
            var that = this
            if (that.info.name == '') {
                that.$errMsg('请输入名称')
                return
            } else if (that.info.cover == '') {
                that.$errMsg('请上传封面')
                return
            } else if (that.type == 1) {
                // 添加
                that.btnLoading = true
                var params = {
                    cover: this.info.cover,
                    status: this.info.status,
                    name: this.info.name,
                    uid: this.ids.toString(),
                }
                that.$memberApi.memberGroupAdd(params).then(res => {
                    that.btnLoading = false
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.cancelBtn()
                        that.$emit('submit')
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            } else if (that.type == 2) {
                // 编辑
                that.btnLoading = true
                var params = {
                    name: this.info.name,
                    cover: this.info.cover,
                }
                that.$memberApi.memberGroupEdit(params, that.id).then(res => {
                    that.btnLoading = false
                    if (res.code == 1000) {
                        that.$succMsg(res.message)
                        that.cancelBtn()
                        that.$emit('submit')
                    } else {
                        that.$errMsg(res.message)
                    }
                })
            }
        },
        // 上传图片限制
        beforeAvatarUpload(file) {
            const isLt10KB = file.size / 1024 / 1024 < 10;
            let types = ['image/jpg', 'image/png', 'image/gif', 'image/jpeg'];
            const isType = types.includes(file.type);
            if (!isType) {
                this.$message.error('只能上传只 JPG/PNG/JEPG/GIF 格式!');
            }
            if (!isLt10KB) {
                this.$message.error('上传图片大小不能超过 10M!');
            }

            return isType && isLt10KB;
        },

        // 上传图片
        httpRequestMultiple(uploader) {
            const formData = new FormData();
            formData.set('file', uploader.file);
            this.$publicApi.uploadFile(formData).then(res => {
                if (res.code === 1000) {
                    this.info.cover = res.result.url
                } else {
                    this.$message.error(res.message);
                }
            })
        },
    },
}
</script>

<style lang='scss' scoped>
.account_add_edit {
    .inv_main {
        width: 100%;
        padding: 10px 20px 0 0;

        .main_text {
            width: 100%;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;

            .left {
                width: 100px;
                line-height: 40px;
                text-align: right;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;

                span {
                    color: #e00c25;
                }
            }

            .right {
                width: 320px;

                .el-input {
                    width: 100%;
                }

                .el-select {
                    width: 100%;
                }
                .el-cascader {
                    width: 100%;
                }
                .right_txt {
                    padding-top: 10px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ff2b2b;
                }

                .r_img {
                    width: 80px;
                    height: 80px;
                    cursor: pointer;
                    border: 1px solid #e8eaec;
                    background-color: #f5f7fa;
                    border-radius: 5px;
                    text-align: center;
                    .r_img_no {
                        padding-top: 20px;
                        font-size: 14px;
                        color: #94979f;
                        i {
                            font-size: 18px;
                        }
                        div {
                            padding-top: 5px;
                        }
                    }
                }
            }
        }
        .main_text:last-child {
            margin-bottom: 0;
        }
    }
}
.w100 {
    width: 100%;
}
.h100 {
    height: 100%;
}

::v-deep .el-switch {
    margin-top: 8px;
}
</style>
